const Base = {
  "projectorTypes": {
      "Short-Throw": {
          "Bright": {
              "CLR": {
                  "r169": {
                      "White": {
                          "100":[{  "30": ["43533160251658"] }], 
                          "120": [{ "30":  ["43533160284426"] }]
                      }
                  }
              },
               "CLR5": {
                  "r169": {
                      "White": {
                          "101":[{  "30": ["52230990528778"] }], 
                          "121": [{ "30":  ["52230994166026"] }]
                      }
                  }
              }
          },
          "Dark": {
              "CLR": {
                  "r169": {
                      "White": {
                          "100": [{ "30": ["43533160251658" ] }],
                          "120": [{ "30":  ["43533160284426" ]}]
                      }
                  }
              },
                  "CLR5": {
                  "r169": {
                      "White": {
                          "101":[{  "30": ["52230990528778"] }], 
                          "121": [{ "30":  ["52230994166026"] }]
                      }
                  }
              }
          }
      },
      "Standard-Throw": {
          "Bright": {
              "Cinegrey": {
                  "r169": {
                      "White": {
                          "92": [{ "30": ["43533160481034" ]}],
                          "100": [{ "30": ["43533160513802" ] }],
                          "110": [{ "30": ["43533160546570" ] }],
                          "120": [{ "30": ["43533160579338" ] }],
                          "135": [{ "25": ["43533160612106" ]}]
                      }
                  }
              }
          },
          "Dark": {
              "MaxWhite": {
                  "r169": {
                      "Black": {
                          "100": [{ "30": ["43533161300234" ] }, { "60": ["43533161333002" ] }],
                          "110": [{ "30": ["43533161365770" ] }, { "60": ["43533161398538" ] }],
                          "135": [{ "15": ["43533161496842" ] }, { "60": ["43533161529610" ]}],
                          "150": [{ "15": ["43533161562378" ] }, { "60": ["43533161595146" ] }]
                      },
                      "White": {
                          "84": [{ "30": ["43533160644874" ] }, { "60": ["43533160677642" ] }],
                          "100": [{ "30": ["43533160710410" ] }, { "60": ["43533160743178" ] }],
                          "110": [{ "30": ["43533160775946" ] }, { "60": ["43533160808714" ] }],
                          "120": [{ "25": ["43533160841482" ] }, { "50": ["43533160874250" ] }],
                          "135": [{ "15": ["43533160907018" ] }, { "60": ["43533160939786" ] }],
                          "150": [{ "15": ["43533160972554" ] }, { "60": ["43533161005322" ] }],
                          "180": [{ "15": ["43533161169162" ] }]
                      }
                  },
                  "r1610": {
                      "White": {
                          "106": [{ "30": ["43533161201930" ] }],
                          "120": [{ "30": ["43533161234698" ] }],
                          "135": [{ "10": ["43533161267466" ] }]
                      }
                  }
              },
              "AcousticPro": {
                  "r169": {
                      "White": {
                          "100": [{ "60": ["43533160317194" ] }],
                          "110": [{ "60": ["43533160349962" ] }],
                          "120": [{ "50": ["43533160382730" ] }],
                          "135": [{ "30": ["43533160415498" ] }],
                          "150": [{ "30": ["43533160448266" ] }]
                      }
                  }
              },
              "Cinegrey": {
                  "r169": {
                     "White": {
                          "92": [{ "30": ["43533160481034" ]}],
                          "100": [{ "30": ["43533160513802" ] }],
                          "110": [{ "30": ["43533160546570" ] }],
                          "120": [{ "30": ["43533160579338" ] }],
                          "135": [{ "25": ["43533160612106" ]}]
                      }
                  }
              }
          }
      }
  }
};

/* PRE CLEANUP
const Base={
  
    "projectorTypes": {
      "Short-Throw": {
        "Bright": {
          "CLR": {
            "r169": {
              "White": {
                "110": ["30"],
                "120": ["30"]
              }
            }
          }
        },
        "Dark": {
          "CLR": {
            "r169": {
              "White": {
                "110": ["30"],
                "120": ["30"]
              }
            }
          }
        }
      },
      "Standard-Throw": {
        "Bright": {
          "Cinegrey": {
            "r169": {
              "White": {
                "92": ["25", "30", "60"],
                "100": ["25", "30", "60"],
                "110": ["25", "30", "60"],
                "120": ["25", "30", "60"],
                "135": ["25", "30", "60"]
              }
            }
          }
        },
        "Dark": {
          "MaxWhite": {
            "r169": {
              "Black": {
                "100": ["15", "25", "60"],
                "110": ["15", "25", "60"],
                "135": ["15", "25", "60"],
                "150": ["15", "25", "60"]
              },
              "White": {
                "84": ["10", "15", "30", "60"],
                "100": ["10", "15", "30", "60"],
                "110": ["10", "15", "30", "60"],
                "120": ["10", "15", "30", "60"],
                "135": ["10", "15", "30", "60"],
                "150": ["10", "15", "30", "60"]
              }
            },
            "r1610": {
              "White": {
                "106": ["10", "30"],
                "120": ["10", "30"],
                "135": ["10", "30"]
              }
            }
          },
          "AcousticPro": {
            "r169": {
              "White": {
                "100": ["30", "50", "60"],
                "110": ["30", "50", "60"],
                "120": ["30", "50", "60"],
                "135": ["30", "50", "60"],
                "150": ["30", "50", "60"],
                "165": ["30", "50", "60"]
              }
            }
          },
          "Cinegrey": {
            "r169": {
              "White": {
                "92": ["25", "30", "60"],
                "100": ["25", "30", "60"],
                "110": ["25", "30", "60"],
                "120": ["25", "30", "60"],
                "135": ["25", "30", "60"]
              }
            }
          }
        }
      }
    }
  }
*/
  
var selection={
    "Beamer":'Standard-Throw',
    "Ambience":'Dark',
    "Material":'MaxWhite',
    "Aspect":'r169',
    "CaseColor":'White',
    "Size":100,
    "TopDrop":30,
    "ProdVariant":"43533160710410",
}

/*
document.getElementById('testAvCall').addEventListener("click", function() {
  // Hier kommt die Funktion, die beim Klick ausgeführt wird
  var testAr = Object.keys(Base.projectorTypes[selection.Beamer][selection.Ambience][selection.Material][selection.Aspect][selection.CaseColor]);
  console.log(testAr);
  var testqueste = Object.keys(Base[selection.Beamer]?.[selection.Ambiance]?.[selection.Material]?.[selection.Aspect]?.[selection.CaseColor] || {});
  console.log(testqueste);
});
*/

function showMip(){
  return Base[selection.Beamer]?.[selection.Ambiance]?.[selection.Material]?.[selection.Aspect]?.[selection.CaseColor] || {};
}


  function selectBeamer(){
    selection.Beamer= $(this).attr("id");
   console.log(selection.Beamer);
  }

const CLR = document.getElementById("CLR");
const CLR5 = document.getElementById("CLR5");
const AcousticPro = document.getElementById("AcousticPro");
const MaxWhite = document.getElementById("MaxWhite");
const Cinegrey = document.getElementById("Cinegrey");

const r169 = document.getElementById("r169");
const r1610 = document.getElementById("r1610");
var avMaterials;

document.getElementById("Bright").addEventListener("click",setAmbiance);
document.getElementById("Dark").addEventListener("click",setAmbiance);

//document.getElementById("resetFilter").addEventListener("click",resetFilter);

/*
function resetFilter(){
  CLR.style.display="inline-flex"
  AcousticPro.style.display="inline-flex"
  MaxWhite.style.display="inline-flex"
  Cinegrey.style.display="inline-flex"
} */

document.querySelector('.model-div').addEventListener('wheel', function(event) {
    event.preventDefault();
}, { passive: false });

function setAmbiance(){
  selection.Ambience= $(this).attr("id");
  getMaterials();
} 

const buttons = { CLR,CLR5, AcousticPro, MaxWhite, Cinegrey };
const ratio = {r169 ,r1610};

function getMaterials(){
    
   // BEFORE AMB. 
   // var avMaterials = Object.keys(Base.projectorTypes[selection.Beamer].materials);
   
    avMaterials = Object.keys(Base.projectorTypes[selection.Beamer][selection.Ambience]);
    console.log(avMaterials);
    hideUI();

    // Alle verfügbaren Materialien angeben!
   
// Schleife durch die verfügbaren Materialien
for (const key in buttons) {
    if (avMaterials.includes(key)) {
        buttons[key].style.display = "inline-flex"; // Anzeigen
    }
    /* for (let i = 0; i < avMaterials.length; i++) {
      // Dein Code hier
      //avMaterials[i].style.display="block";
      console.log(avMaterials[i]); // Beispiel: Zugriff auf jedes Element
  } */
} }

function getRatios(){

  var avRatios = Object.keys(Base.projectorTypes[selection.Beamer][selection.Ambience][selection.Material]);
  console.log(avRatios);

  r169.style.display="none"
  r1610.style.display="none"

  for (const key in ratio) {
    console.log(key);
    if (avRatios.includes(key)) {
      //console.log(ratio[key]);
        ratio[key].style.display = ""; // Anzeigen
    }
}
}





function hideUI(){
  CLR.style.display="none"
  CLR5.style.display="none"
  AcousticPro.style.display="none"
  MaxWhite.style.display="none"
  Cinegrey.style.display="none"
}



var  formData ={
  'items': [ {
    'id': 43533160710410,
    'quantity': 1
     
    } ]
};
document.getElementById("addCart").addEventListener("click", addItems1);


function addItems1() {
    //console.log("additem " + selection.ProdVariant );
  formData.items[0].id=selection.ProdVariant;
    //console.log("formData: "+ JSON.stringify(formData, null, 2))
  
// fügt in den Cart JS hinzu
fetch(window.Shopify.routes.root + 'cart/add.js', {
  method: 'POST',
  headers: {
    'Content-Type': 'application/json'
  },



  
  body: JSON.stringify(formData)
})
.then(response => {
  return response.json();
})
.catch((error) => {
  console.error('Error:', error);
});

  

  console.log("Added");

 
setTimeout(() => {
    window.location.href = `${window.location.origin}/cart`;
}, "1000");



}


/*
function addItems1() {
  formData.items.id = selection.ProdVariant;

  fetch(window.Shopify.routes.root + 'cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(formData)
  })
  .then(response => response.json())
  .then(data => {
    console.log('Produkt hinzugefügt:', data);

    // Danach die SECTIONS holen
    fetch(window.Shopify.routes.root + '?sections=cart-drawer')
      .then(response => response.json())
      .then(parsedState => {
        const cartDrawer = document.querySelector('cart-drawer');
        if (cartDrawer) {
          if (typeof cartDrawer.renderContents === 'function') {
            cartDrawer.renderContents(parsedState); // <== Jetzt parsedState
          } else {
            console.warn('cartDrawer hat keine renderContents-Methode!');
          }

          if (typeof cartDrawer.open === 'function') {
            cartDrawer.open();
          }
        } else {
          console.warn('Kein cart-drawer gefunden!');
        }
      });
  })
  .catch((error) => {
    console.error('Error:', error);
  });

  fetch(window.Shopify.routes.root + '?sections=cart-drawer')
  .then(response => response.json())
  .then(parsedState => {
    console.log('Sections Response:', parsedState); // <-- hier
    
    const cartDrawer = document.querySelector('cart-drawer');
    if (cartDrawer) {
      if (typeof cartDrawer.renderContents === 'function') {
        cartDrawer.renderContents(parsedState);
      } else {
        console.warn('cartDrawer hat keine renderContents-Methode!');
      }

      if (typeof cartDrawer.open === 'function') {
        cartDrawer.open();
      }
    } else {
      console.warn('Kein cart-drawer gefunden!');
    }
  });
  
}

/*
function bC(){

  console.log("BC");
  
  document.dispatchEvent(new CustomEvent('cart:build'));

  document.dispatchEvent(new CustomEvent('ajaxProduct:added', {
          detail: {
            product: formData,
            addToCartBtn: this.addToCart
          }
        }));
}
*/

